import { formatSuggestedReplyHtml } from './formatSuggestedReplyHtml';

/** Closing phrases used to split the body around the locked CTA (FR / EN / DE). */
const REGARDS_HTML_RE = /(<p[^>]*>\s*(?:Cordialement|Best\s+regards|Freundliche\s+Grüsse)[\s\S]*?<\/p>)/i;

export function formatSenderSignature(user?: { firstname?: string; lastname?: string } | null): string {
    const firstname = String(user?.firstname || '').trim();
    const lastname = String(user?.lastname || '').trim().toUpperCase();
    const name = [firstname, lastname].filter(Boolean).join(' ');
    return name ? `${name}.` : '';
}

export function buildDefaultEmailBodyPlain(params: {
    quote: { name?: string; slug?: string | number; project?: { name?: string } | null };
    readOnly: boolean;
    /** @deprecated prefer hasIncludedOptions */
    hasRemovable?: boolean;
    hasIncludedOptions?: boolean;
    hasExcludedOptions?: boolean;
    hasQuantityEditable: boolean;
    senderSignature: string;
    t: (key: string, options?: AnyObj) => string;
}): string {
    const {
        quote,
        readOnly,
        hasRemovable,
        hasIncludedOptions,
        hasExcludedOptions,
        hasQuantityEditable,
        senderSignature,
        t,
    } = params;
    const included = !!(hasIncludedOptions ?? hasRemovable);
    const excluded = !!hasExcludedOptions;
    const projectName = quote.project?.name || '';
    const intro = projectName
        ? String(t('quotes.send_body_intro_with_project', {
            name: quote.name,
            slug: quote.slug,
            project: projectName,
        }))
        : String(t('quotes.send_body_intro', {
            name: quote.name,
            slug: quote.slug,
        }));
    const lines = [
        String(t('quotes.send_body_greeting')),
        '',
        intro,
        '',
        String(readOnly ? t('quotes.send_body_action_readonly') : t('quotes.send_body_action')),
    ];
    if (!readOnly && (included || excluded || hasQuantityEditable)) {
        const parts: string[] = [];
        if (included)
            parts.push(String(t('quotes.send_body_optional_note')));
        if (excluded)
            parts.push(String(t('quotes.send_body_activatable_note')));
        if (hasQuantityEditable)
            parts.push(String(t('quotes.send_body_quantity_note')));
        lines.push('', parts.join(' '));
    }
    lines.push('', String(t('quotes.send_body_regards')));
    if (senderSignature)
        lines.push('', senderSignature);
    return lines.join('\n');
}

export function buildDefaultEmailBodyHtml(params: Parameters<typeof buildDefaultEmailBodyPlain>[0]): string {
    return formatSuggestedReplyHtml(buildDefaultEmailBodyPlain(params));
}

export function splitEmailBodyAtRegards(html: string): { before: string; after: string } {
    const value = String(html || '');
    const match = REGARDS_HTML_RE.exec(value);
    if (!match || match.index == null) {
        return { before: value, after: '' };
    }
    return {
        before: value.slice(0, match.index).trim(),
        after: value.slice(match.index).trim(),
    };
}

export function joinEmailBodyParts(before: string, after: string): string {
    return [String(before || '').trim(), String(after || '').trim()]
        .filter(Boolean)
        .join('');
}
